const API_BASE = import.meta.env.VITE_API_URL;

export const authService = {
  async register(name: string, email: string, password: string) {
    const response = await fetch(`${API_BASE}/auth/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, password }),
    });
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Registration failed');
    }
    return response.json();
  },

  async login(email: string, password: string) {
    const response = await fetch(`${API_BASE}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Invalid credentials');
    }
    return response.json();
  },

  async verifyEmail(token: string) {
    const response = await fetch(`${API_BASE}/auth/verify-email?token=${encodeURIComponent(token)}`, {
      method: 'GET',
    });
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Failed to verify email');
    }
    return response.json();
  },

  async forgotPassword(email: string) {
    const response = await fetch(`${API_BASE}/auth/forgot-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Failed to process request');
    }
    return response.json();
  },

  async resetPassword(token: string, password: string) {
    const response = await fetch(`${API_BASE}/auth/reset-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, password }),
    });
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Failed to reset password');
    }
    return response.json();
  },

  async updateProfile(token: string, data: { name?: string, email?: string, currentPassword?: string, newPassword?: string }) {
    const response = await fetch(`${API_BASE}/auth/me`, {
      method: 'PATCH',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Failed to update profile');
    }
    return response.json();
  }
};